import React, { useEffect, useState } from 'react';
import { PlayIcon, SquareIcon } from 'lucide-react';
import { ProcessingTag } from '../../ui/ProcessingTag';
import { voices } from '../../../data/beheer/persona';
import { cancelSpeech, speakDutch } from '../../../utils/tts';
const SAMPLE = 'Hoi, ik ben Anna. Zo klink ik als ik je iets vertel.';
interface VoicesPanelProps {
  selected: string;
  onSelect: (id: string) => void;
}
export function VoicesPanel({
  selected,
  onSelect
}: VoicesPanelProps) {
  const [playing, setPlaying] = useState<string | null>(null);
  useEffect(() => () => cancelSpeech(), []);
  const play = (id: string) => {
    if (playing === id) {
      cancelSpeech();
      setPlaying(null);
      return;
    }
    setPlaying(id);
    const ok = speakDutch(SAMPLE, {
      onEnd: () => setPlaying(p => p === id ? null : p)
    });
    if (!ok) window.setTimeout(() => setPlaying(null), 1500);
  };
  return <ul role="radiogroup" aria-label="Stem" className="divide-y divide-white/[0.06] rounded-3xl border border-white/[0.07] bg-night-900 px-5" data-id="element-146" data-mp="1f5yowebcl4md">
      {voices.map(v => {
      const active = v.id === selected;
      return <li key={v.id} className="flex items-center gap-4 py-4" data-id="element-147" data-mp="3rzwmi6gpg4u0">
            <button type="button" role="radio" aria-checked={active} onClick={() => onSelect(v.id)} className="flex min-w-0 flex-1 items-center gap-4 rounded-xl text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent/60" data-id="element-148" data-mp="3dzvdu4u77t3z">
              <span aria-hidden className={`grid h-5 w-5 shrink-0 place-items-center rounded-full border ${active ? 'border-accent' : 'border-white/25'}`} data-id="element-149" data-mp="393wtqtfwkx9d">
                {active && <span className="h-2.5 w-2.5 rounded-full bg-accent" data-id="element-150" data-mp="2z9o0u4myn2ao" />}
              </span>
              <span className="min-w-0" data-id="element-151" data-mp="2lec6vzgmpfut">
                <span className="block text-[15px] font-medium text-ink" data-id="element-152" data-mp="2qblud9kgjhg0">{v.name}</span>
                <span className="block truncate text-[13px] text-ink-muted" data-id="element-153" data-mp="vvngus59qlwo">
                  {v.engine} · {v.note}
                </span>
              </span>
            </button>
            <ProcessingTag where={v.where} data-id="element-154" data-mp="m5anqbje1kex" />
            <button type="button" onClick={() => play(v.id)} aria-label={playing === v.id ? `Stop ${v.name}` : `Luister naar ${v.name}`} className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-white/[0.06] text-ink-soft transition-colors duration-150 hover:bg-white/[0.11] hover:text-ink" data-id="element-155" data-mp="m6c856manj9b">
              {playing === v.id ? <SquareIcon className="h-3.5 w-3.5" data-id="element-156" data-mp="15s8mnfp4411k" /> : <PlayIcon className="h-3.5 w-3.5" data-id="element-157" data-mp="15vedp0haxczx" />}
            </button>
          </li>;
    })}
    </ul>;
}